<template>
	<div class="rounded-xl border-2 bg-color-4 border-color-5 p-5 md:p-10 md:pb-12 flex flex-col" v-bind:class="addclass">
		<div class="w-full flex justify-center">
			<div class="font-bold text-4xl font-cooper text-color-text">{{ title }}</div>
		</div>
		<div v-show="subtitle" class="w-full flex justify-center pt-1">
			<div class="text-base text-color-text">{{ subtitle }}</div>
		</div>
		<slot></slot>
	</div>
</template>
<script>
export default {
	name: "Panel",
	props: ['title', 'subtitle', 'addclass'],
}
</script>
